import { showCreateInvite } from './create/show-create.js'
import { showInviteList } from './show/show-invite-list.js'

export function showInvites (params) {
  console.log('showInvites', params)
  const { browserAppAccount } = params

  if (!browserAppAccount.data.userRights?.includes('canManage')) return

  showInviteList(params)
  showCreateInvite(params)

  document.getElementById(params.create?.containerElementId)?.addEventListener('inviteCreated', function () {
    console.log('listener inviteCreated')
    showInviteList(params)

    if (typeof params.create?.callback === 'function') {
      params.create.callback()
    }
  })
}
